export default __webpack_public_path__ + "static/media/ext2.c1f1d92e.JPG";